import React from 'react';
import PropTypes from 'prop-types';

/**
 * Universal Skeleton Primitive
 * Replaces: Hardcoded "Loading..." text strings and legacy .loading CSS blocks
 */
const Skeleton = ({ 
  variant = 'text', 
  width, 
  height, 
  className = '',
  circle = false
}) => {
  const baseStyles = 'animate-pulse bg-gray-200';
  
  const variants = {
    text: 'rounded',
    rectangular: 'rounded-md',
    circular: 'rounded-full'
  };

  const finalVariant = circle ? 'circular' : variant;

  const styleOverrides = {
    ...(width && { width }),
    ...(height && { height })
  };

  return (
    <div 
      className={`${baseStyles} ${variants[finalVariant]} ${className}`}
      style={styleOverrides}
      aria-hidden="true"
    />
  );
};

Skeleton.propTypes = {
  variant: PropTypes.oneOf(['text', 'rectangular', 'circular']),
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string,
  circle: PropTypes.bool
};

export default Skeleton;
